import { Alert, Form, Typography } from 'antd';
import React, { forwardRef, useEffect, useMemo, useCallback, useState } from 'react';
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import { EndorLabsBranchTypeFilterAPI } from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes, generateFormFields } from 'utils/formUtils';
import AppLoader from 'components/AppLoader';

const ALL_BRANCH_TYPES = ['Default Branch', 'All Branches', 'All Branches and PR Scans'];

const EndorLabsBranchTypeFilter = forwardRef(({ toolName }, ref) => {
    const [form] = Form.useForm();
    const { globalFilterHash } = useGlobalFilterContext();
    const [loading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const resData = await EndorLabsBranchTypeFilterAPI.getConfiguredBranchTypeFilter().promise;
            const branchType = resData?.config?.branchType || 'All Branches and PR Scans';
            form.setFieldsValue({
                branchType: branchType
            });
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [form]);

    useEffect(() => {
        fetchData();
    }, [globalFilterHash, fetchData]);

    const fields = useMemo(() => [{
        name: "branchType",
        label: <Typography.Text>Endor Labs Branch Type Filter</Typography.Text>,
        placeholder: "Select branch type to include",
        type: FieldTypes.SELECT,
        options: parseSelectOptions(ALL_BRANCH_TYPES),
        colSpan: 16,
        props: {
            allowClear: false,
        },
        rules: [
            {
                required: true,
                message: 'Please select a branch type'
            }
        ],
        help: "Select which branch types to include when pulling findings from Endor Labs"
    }], []);

    return (
        <Alert
            direction="vertical"
            className="m-b-m"
            description={
                <div>
                    {
                        loading ? <AppLoader /> :
                        <Form
                            form={form}
                            ref={ref}
                            style={{ minWidth: 600 }}
                            layout="vertical"
                        >
                            {generateFormFields(fields)}
                        </Form>
                    }
                </div>
            }
        />
    );
});

export default EndorLabsBranchTypeFilter;

const parseSelectOptions = (options = []) => {
    return options.map(option => ({
        label: option,
        value: option
    }));
};
